<template>
  <div class="page">
    <div class="wrap">
      <n-header></n-header>
      <div class="userbox z-flex z-flex-between">
        <div class="userbox-l z-flex">
          <div class="avatar-wrap z-flex z-flex-center">
              <img class="avatar" :src="userInfo.avatar + '?x-oss-process=image/resize,m_lfit,w_80'">
          </div>
          <div class="username">{{userInfo.nickname}}</div>
        </div>
        <div class="userbox-r z-flex z-flex-end">
          <div class="r-item">
            <div class="r-item-top"><span class="r-item-num">{{userInfo.order_num}}</span>张</div>
            <div class="r-item-bottom z-flex z-flex-center">
              <i class="icon el-icon-picture"></i>
              <span>已购图片</span>
            </div>
          </div>
          <div class="r-item">
            <div class="r-item-top"><span class="r-item-num">0</span>元</div>
            <div class="r-item-bottom z-flex z-flex-center">
              <i class="icon el-icon-s-finance"></i>
              <span>可提现余额</span>
            </div>
          </div>
          <div class="r-item">
            <div class="r-item-top"><span class="r-item-num">0</span>元</div>
            <div class="r-item-bottom z-flex z-flex-center">
              <i class="icon el-icon-s-check"></i>
              <span>提现审核中</span>
            </div>
          </div>
        </div>
      </div> 
      <div class="tabbar z-flex">
        <div class="tabbar-wrap">
          <el-dropdown class="item" :class="activeTab == index ? 'active':''"  
            v-for="(item,index) in tabList" :key="index"
          >
            <span class="el-dropdown-link" @click="clickTab(index,item)">
              <span class="tab-name">{{item.name}}</span>
              <i class="el-icon-caret-bottom" v-if="item.sub"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(subItem,subIndex) in item.sub" :key="subIndex">
                <span @click="clickTab(3,subItem)">{{subItem.name}}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="usercenter">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from "vuex";

export default {
  provide(){
    return{
      setTab:this.setTab, //tab选中
    }
  },
  data() {
    return {
      activeTab:0,
      tabList:[
        { 
          name:'我的套餐',
          url:'/usercenter/list',
        },{ 
          name:'收藏夹',
          url:'/usercenter/likes',
        },{ 
          name:'已购图片',
          url:'/usercenter/imgs',
        }
        /*
        ,{
          name:'售图明细',
          url:'/usercenter/details',
          sub:[
            { 
              name:'售图明细',
              url:'/usercenter/details',
            },{ 
              name:'我要提现',
              url:'/usercenter/withdrawal',
            }
          ],
        },
              */
      ],
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    userInfo: {
      set(val) {
        this.setUserInfo(val);
      },
      get() {
        return this.getUserInfo;
      },
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: "userInfo"
    }),
    //切换tab
    clickTab(index,item){
      this.activeTab = index
      this.$router.push({path: item.url});
      if(index == 3){
        this.tabList[3].name = item.name
        this.tabList[3].url = item.url
      }
    },
    //保持tab选中
    setTab(tabIndex,subIndex){
      this.activeTab = tabIndex
      if(subIndex){
        this.tabList[tabIndex].name = this.tabList[tabIndex].sub[subIndex].name
        this.tabList[tabIndex].url = this.tabList[tabIndex].sub[subIndex].url
      }
    }
  },
};
</script>
<style lang="scss" scoped>
  .page{
    background:#f3f5f9!important;
  }
  .wrap{
    overflow: hidden;
  }
  .userbox{
    background:#fff;
    margin-top:100px;
    padding: 40px;
    .avatar-wrap {
      width: 108px;
      height: 108px;
      border-radius: 100%;
      background-image: linear-gradient(140deg, #ff4216, #ffddc7);
      margin-right: 20px;
      .avatar {
        width: 100px;
        height: 100px;
        display: block;
        object-fit: cover;
        border-radius: 100%;
      }
    }
    .username {
      font-size: 24px;
      max-width: 320px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .userbox-r{
      .r-item{
        min-width: 200px;
        padding: 0 10px;
        text-align: center;
        position: relative;
        .r-item-top {
          color: #666;
          .r-item-num {
            font-size: 24px;
            color: #333;
            margin-right: 5px;
          }
        }
        .r-item-bottom {
          font-size: 18px;
          color: #999;
          margin-top: 20px;
          .icon{
            color: #ec7a5d;
            font-size: 24px;
            margin-right: 6px;
          }
        }
      }
      .r-item::after {
        content: "";
        display: block;
        width: 1px;
        height: 40px;
        background: #eee;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -20px;
      }
      .r-item:last-child::after{
        display: none;
      }
    }
  }
  .tabbar{
    height:70px;
    background:#fff;
    margin-top:2px;
    padding:0 20px;
    .tabbar-wrap{
      width:100%;
      border-bottom: 1px solid #f3f5f9;
    }
    .item{
      margin: 0 40px;
      font-size: 18px;
      cursor: pointer;
      color: #666;
      .tab-name{
        display: inline-block;
        height:70px;
        line-height:70px;
      }
    }
    .item:first-child{
      margin: 0 40px 0 0;
    }
    .item.active{
      .tab-name{
        color: #f77e5e;
        border-bottom: 2px solid #f77e5e;
      }
    }
    .item:hover{
      color: #f77e5e;
    }
    .item.active .el-icon-caret-bottom{
      color: #f77e5e;
    }
  }
  .usercenter{
    background: #fff;
    overflow: hidden;
    padding:20px;
    margin-bottom: 50px;
    .usercenter-con{
      min-height: 600px;
    }
  }
</style>
